import * as React from "react";
import { gql /*useQuery*/ } from "@apollo/client";
import { useDispatch } from "context";
// import { StateType } from "context/state";
import finalData from "./resp.json";

export const getLeaderBoardQuery = gql`
  query BattleOfYields {
    getLeaderBoard {
      timestamp
      leaderboard {
        address
        nonce
        netWorth
        balanceUSD
        balance
        teamMember
        userTokens {
          balance
          decimals
          identifier
          name
          type
          valueUSD
        }
        userNftTokens {
          ... on UserLockedAssetToken {
            identifier
            valueUSD
            identifier
            collection
            name
            balance
          }
          ... on UserFarmToken {
            identifier
            valueUSD
            identifier
            collection
            name
            balance
            decodedAttributes {
              lockedRewards
              initialFarmingAmount
              compoundedReward
              currentFarmAmount
            }
          }
          ... on UserLockedLPToken {
            identifier
            valueUSD
            identifier
            collection
            name
            balance
            decodedAttributes {
              lpTokenID
            }
          }
          ... on UserLockedFarmToken {
            identifier
            valueUSD
            identifier
            collection
            name
            balance
            decodedAttributes {
              farmTokenID
              farmTokenAttributes {
                lockedRewards
              }
            }
          }
          ... on UserNftToken {
            identifier
            valueUSD
            identifier
            collection
            name
            balance
          }
        }
      }
    }
  }
`;

const Provider = ({ children }: { children: React.ReactNode }) => {
  // const { data, error, loading } = useQuery<{
  //   getLeaderBoard: StateType["leaders"]["data"];
  // }>(getLeaderBoardQuery);
  const dispatch = useDispatch();

  React.useEffect(
    () => {
      dispatch({
        type: "setLeaders",
        // leaders: { data: data?.getLeaderBoard, error, loading },
        leaders: {
          data: (finalData as any).data.getLeaderBoard,
          error: "",
          loading: false,
        },
      });
    },
    [
      /*data, error, loading*/
    ],
  );

  return <>{children}</>;
};
export default Provider;
